import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import Typography from '@material-ui/core/Typography';
import * as React from 'react';
import { DRAWER_WIDTH } from '../layout/layoutConstants';

export interface IBannerProps {
  buttonText?: string;
  hideButton?: boolean;
  text: string;
  visible: boolean;
  onButtonClick?: () => any;
  icon?: React.ComponentType<SvgIconProps>;
  children?: React.ReactNode;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    absolute: {
      position: 'absolute'
    },
    button: {
      flexShrink: 1
    },
    container: {
      alignItems: 'center',
      backgroundColor: theme.palette.background.paper,
      borderBottomColor: theme.palette.divider,
      borderBottomStyle: 'solid',
      borderBottomWidth: 1,
      display: 'flex',
      paddingBottom: theme.spacing(),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(),
      paddingTop: theme.spacing(),
      position: 'absolute',
      width: `calc(100% - ${DRAWER_WIDTH}px)`,
      zIndex: theme.zIndex.snackbar
    },
    content: {
      flexGrow: 1,
      marginRight: theme.spacing()
    },
    icon: {
      color: theme.palette.error.main,
      flexShrink: 0,
      fontSize: theme.spacing(),
      marginRight: theme.spacing(2)
    }
  })
);

let Banner: React.FunctionComponent<IBannerProps> = ({
  buttonText,
  children,
  text,
  visible,
  onButtonClick,
  ...props
}) => {
  const classes = useStyles();

  return (
    <Collapse in={visible}>
      <div className={classes.container}>
        {props.icon && <props.icon className={classes.icon} />}
        <div className={classes.content}>
          <Typography variant="body1">{text}</Typography>
          {children}
        </div>
        <Button className={classes.button} onClick={onButtonClick ? onButtonClick : undefined}>
          {buttonText ? buttonText : 'Action'}
        </Button>
      </div>
    </Collapse>
  );
};

Banner = React.memo<IBannerProps>(Banner);
export { Banner };
